<h2 mat-dialog-title>{{ data.person.id ? 'Edit Certified Individual' : 'Add Certified Individual' }}</h2>

<mat-dialog-content>
  <form [formGroup]="personForm">
    <div class="dialog-body" fxLayout="column" fxLayoutGap="16px">
      <div class="lookup-intro">Only existing people already in the system can be added to a Firm application.</div>

      <mat-form-field>
        <mat-label>Search Existing People</mat-label>
        <input matInput formControlName="selectedPerson" [matAutocomplete]="personAutocomplete">
        <mat-autocomplete #personAutocomplete="matAutocomplete" [displayWith]="displayPerson.bind(this)">
          <mat-option *ngFor="let personOption of matchingPeople" [value]="personOption">
            {{ displayPerson(personOption) }}
          </mat-option>
        </mat-autocomplete>
        <mat-hint>Type at least 3 characters to search.</mat-hint>
        <mat-error *ngIf="showSelectedPersonRequiredError()">Select an existing person.</mat-error>
        <mat-error *ngIf="showSelectedPersonLookupError()">{{ selectedPersonErrorMessage }}</mat-error>
      </mat-form-field>

      <div class="lookup-empty" *ngIf="searchCompleted && !matchingPeople.length">No matching existing people were found.</div>

      <div class="selected-person-summary" *ngIf="selectedPerson as currentPerson">
        <div><strong>Selected Person:</strong> {{ displayPerson(currentPerson) }}</div>
      </div>

      <ng-container *ngIf="isRrpApplication">
        <mat-form-field>
          <mat-label>Training Provider</mat-label>
          <input matInput formControlName="atp">
          <mat-error *ngIf="personForm.get('atp').hasError('required')">Training provider is required.</mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Training Date</mat-label>
          <input matInput [matDatepicker]="trainingDatePicker" formControlName="trainingDate">
          <mat-datepicker-toggle matSuffix [for]="trainingDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #trainingDatePicker></mat-datepicker>
          <mat-error *ngIf="personForm.get('trainingDate').hasError('required')">Training date is required.</mat-error>
        </mat-form-field>
      </ng-container>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-raised-button color="primary" (click)="save()">Save</button>
</mat-dialog-actions>